(function () {
  function init(root) {
    if (root.dataset.cwReady) return;
    root.dataset.cwReady = 'true';
    const steps = [...root.querySelectorAll('[data-cw-step]')];
    const views = [...root.querySelectorAll('[data-cw-view]')];
    const tabs = [...root.querySelectorAll('[data-cw-tab]')];
    const panels = [...root.querySelectorAll('[data-cw-panel]')];
    const products = [...root.querySelectorAll('[data-cw-product]')];
    const notice = root.querySelector('[data-cw-notice]');
    const buyButton = root.querySelector('[data-cw-buy]');
    const buyLabel = root.querySelector('[data-cw-buy-label]');
    const error = root.querySelector('[data-cw-error]');
    const picks = { full: null, addon: null };
    let pending = false;

    function showStep(key, focus) {
      steps.forEach(function (step) {
        const active = step.dataset.cwStep === key;
        step.classList.toggle('is-active', active);
        if (active) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      views.forEach(function (view) {
        view.hidden = view.dataset.cwView !== key;
        if (!view.hidden && focus) {
          const heading = view.querySelector('h2');
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      });
    }

    function showCategory(key) {
      tabs.forEach(function (tab) {
        const active = tab.dataset.cwTab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.cwPanel !== key;
      });
    }

    function rememberPick(card, kind) {
      const slot = root.querySelector('[data-cw-slot="' + kind + '"]');
      const media = slot.querySelector('.cw-selection__image');
      const image = card.querySelector('.cw-card__image');
      media.replaceChildren();
      if (image) {
        const thumbnail = document.createElement('img');
        thumbnail.src = image.currentSrc || image.src;
        thumbnail.alt = '';
        thumbnail.width = 56;
        thumbnail.height = 56;
        media.append(thumbnail);
      } else {
        media.textContent = '✓';
      }
      slot.querySelector('.cw-selection__name').textContent = card.querySelector('h3').textContent;
      slot.classList.add('is-selected');
      root.querySelector('[data-cw-selection]').hidden = false;
      root.classList.add('has-selection');
    }

    function chooseProduct(product, advance) {
      const button = product.querySelector('[data-cw-select]');
      const select = product.querySelector('select');
      if (pending || button.disabled || !select.value || select.selectedOptions[0].disabled) return;
      const kind = product.dataset.cwKind === 'full' ? 'full' : 'addon';
      picks[kind] = { id: select.value };
      rememberPick(product.closest('[data-cw-card]'), kind);
      products.forEach(function (item) {
        const itemKind = item.dataset.cwKind === 'full' ? 'full' : 'addon';
        const active = picks[itemKind] && picks[itemKind].id === item.querySelector('select').value;
        const itemButton = item.querySelector('[data-cw-select]');
        item.closest('[data-cw-card]').classList.toggle('is-selected', Boolean(active));
        itemButton.setAttribute('aria-pressed', String(Boolean(active)));
        item.querySelector('[data-cw-button-label]').textContent = active ? root.dataset.selected : itemButton.dataset.cwLabel;
      });
      buyButton.disabled = !(picks.full && picks.addon);
      error.hidden = true;
      notice.textContent = kind === 'full' ? root.dataset.fullSelected : root.dataset.addonSelected;
      notice.hidden = false;
      if (kind === 'full' && advance) showStep('addon', true);
    }

    root.addEventListener('click', async function (event) {
      const step = event.target.closest('[data-cw-step], [data-cw-go]');
      if (step) showStep(step.dataset.cwStep || step.dataset.cwGo, true);
      const tab = event.target.closest('[data-cw-tab]');
      if (tab) showCategory(tab.dataset.cwTab);
      if (event.target.closest('[data-cw-browse-all]')) {
        showCategory('all');
        tabs.find(function (item) { return item.dataset.cwTab === 'all'; }).focus();
      }
      const selectButton = event.target.closest('[data-cw-select]');
      if (selectButton) chooseProduct(selectButton.closest('[data-cw-product]'), true);
      if (event.target.closest('[data-cw-buy]')) {
        event.preventDefault();
        if (pending || buyButton.disabled || !picks.full || !picks.addon) return;
        pending = true;
        buyButton.disabled = true;
        buyButton.setAttribute('aria-busy', 'true');
        const originalLabel = buyLabel.textContent;
        buyLabel.textContent = root.dataset.adding;
        error.hidden = true;
        products.forEach(function (product) { product.querySelector('select').disabled = true; });
        try {
          // shortcut: ordinary product prices apply; connect the campaign discount before launch.
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [picks.full, picks.addon].map(function (pick) {
              return { id: pick.id, quantity: 1 };
            }) })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || root.dataset.error);
          notice.textContent = root.dataset.added;
          notice.hidden = false;
          try {
            if (window.HPBMiniCart) await window.HPBMiniCart.refresh({ open: true });
            else window.location.assign(root.dataset.cartUrl);
          } catch {
            window.location.assign(root.dataset.cartUrl);
          }
        } catch (failure) {
          error.textContent = failure.message || root.dataset.error;
          error.hidden = false;
        } finally {
          pending = false;
          buyButton.disabled = false;
          buyButton.removeAttribute('aria-busy');
          buyLabel.textContent = originalLabel;
          products.forEach(function (product) { product.querySelector('select').disabled = false; });
        }
      }
    });

    root.addEventListener('keydown', function (event) {
      const index = tabs.indexOf(event.target);
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      showCategory(tabs[next].dataset.cwTab);
      tabs[next].focus();
    });

    root.addEventListener('change', function (event) {
      if (!event.target.matches('select[name="id"]')) return;
      const card = event.target.closest('[data-cw-card]');
      const option = event.target.selectedOptions[0];
      const price = card.querySelector('[data-cw-price]');
      if (price) price.innerHTML = option.dataset.price;
      const image = card.querySelector('.cw-card__image');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      if (card.classList.contains('is-selected')) chooseProduct(event.target.closest('[data-cw-product]'), false);
    });

    const anchoredPanel = [root.querySelector('[id$="-full"][id^="cw-panel-"]'), ...panels].find(function (panel) {
      return panel && '#' + panel.id === window.location.hash;
    });
    showStep(anchoredPanel && anchoredPanel.dataset.cwPanel ? 'addon' : 'full', false);
    if (anchoredPanel && anchoredPanel.dataset.cwPanel) showCategory(anchoredPanel.dataset.cwPanel);
    if (anchoredPanel) anchoredPanel.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  document.querySelectorAll('[data-cyber-week]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-cyber-week]').forEach(init);
  });
})();
